import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar/Navbar';
import Hero from './components/Hero/Hero';
import Features from './components/Features/Features';
import Vehicles from './components/Vehicles/Vehicles';
import Testimonials from './components/Testimonials/Testimonials';
import QuoteForm from './components/QuoteForm/QuoteForm';
import StickyCta from './components/StickyCta/StickyCta';
import ScrollTop from './components/ScrollTop/ScrollTop';
import Footer from './components/Footer/Footer';
import { I18nProvider } from './i18n/I18n';
import RouteAnalytics from './analytics/RouteAnalytics';

const About = lazy(() => import('./components/About/About'));
const FAQ = lazy(() => import('./pages/FAQ'));
const Terms = lazy(() => import('./pages/Terms'));
const Contact = lazy(() => import('./pages/Contact'));
const NotFound = lazy(() => import('./pages/NotFound'));
const Seo = lazy(() => import('./components/Seo/Seo'));
const CityLanding = lazy(() => import('./pages/CityLanding'));
const Corporate = lazy(() => import('./pages/Corporate'));
const Kvkk = lazy(() => import('./pages/Kvkk'));
const CookiePolicy = lazy(() => import('./pages/CookiePolicy'));
const SLA = lazy(() => import('./pages/SLA'));
const Thanks = lazy(() => import('./pages/Thanks'));
const Individual = lazy(() => import('./pages/Individual'));
const Fleet = lazy(() => import('./pages/Fleet'));

// Ana sayfa bileşeni
const HomePage = () => (
  <>
    <Seo
      title="MEZ Araç Kiralama – Uzun Dönem Kurumsal Kiralama"
      description="Uzun dönem kurumsal araç kiralama – uygun fiyat, geniş filo, hızlı teslimat."
      jsonLd={[{
        key: 'localbusiness',
        data: {
          '@context': 'https://schema.org',
          '@type': 'LocalBusiness',
          name: 'MEZ Araç Kiralama',
          telephone: '+90-212-468-0860',
          url: typeof window !== 'undefined' ? window.location.origin : 'https://www.mez.com',
          address: {
            '@type': 'PostalAddress',
            addressCountry: 'TR'
          },
          sameAs: ['https://instagram.com/mezkiralama']
        }
      },{
        key: 'service_offer',
        data: {
          '@context': 'https://schema.org',
          '@type': 'Service',
          name: 'Uzun Dönem Araç Kiralama',
          description: 'Kurumsal müşteriler için uzun dönem araç kiralama hizmeti. Bakımlı geniş filo, SLA güvencesi ve şeffaf süreçler.',
          areaServed: { '@type': 'Country', name: 'TR' },
          provider: {
            '@type': 'Organization',
            name: 'MEZ Araç Kiralama',
            telephone: '+90-212-468-0860',
            url: typeof window !== 'undefined' ? window.location.origin : 'https://www.mez.com'
          },
          offers: {
            '@type': 'Offer',
            priceSpecification: {
              '@type': 'PriceSpecification',
              price: 0,
              priceCurrency: 'TRY'
            },
            availability: 'https://schema.org/InStock',
            priceValidUntil: new Date(new Date().getFullYear(), 11, 31).toISOString().slice(0,10),
            itemOffered: { '@type': 'Service', name: 'Uzun Dönem Araç Kiralama' }
          }
        }
      }]}
    />
    <Hero />
    <Features />
    <Vehicles />
    <Testimonials />
  </>
);

function App() {
  return (
    <I18nProvider>
      <Router>
        <a href="#main" style={{ position: 'absolute', left: -9999, top: 'auto' }} className="skip-link">İçeriğe geç</a>
        <div id="main">
          <RouteAnalytics />
          <Navbar />
          <Suspense fallback={<div style={{ maxWidth: 800, margin: '2rem auto', textAlign: 'center' }}>Yükleniyor…</div>}>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/hakkimizda" element={<About />} />
              <Route path="/kurumsal-kiralama" element={<Corporate />} />
              <Route path="/bireysel-kiralama" element={<Individual />} />
              <Route path="/arac-filomuz" element={<Fleet />} />
              <Route path="/kvkk" element={<Kvkk />} />
              <Route path="/cerez-politikasi" element={<CookiePolicy />} />
              <Route path="/sla" element={<SLA />} />
              <Route path="/teklif" element={<QuoteForm />} />
              <Route path="/sss" element={<FAQ />} />
              <Route path="/kosullar" element={<Terms />} />
              <Route path="/iletisim" element={<Contact />} />
              <Route path="/tesekkurler" element={<Thanks />} />
              <Route path=":citySlug-arac-kiralama" element={<CityLanding />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Suspense>
          <ScrollTop />
          <StickyCta />
          <Footer />
        </div>
      </Router>
    </I18nProvider>
  );
}

export default App;
